import { render } from "./dots.vue?vue&type=template&id=6a9e1a3a"
import script from "./dots.vue?vue&type=script&lang=js"
export * from "./dots.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__